
import { Component, Vue, Watch } from 'vue-property-decorator'
import AppHeader from '@/components/AppHeader.vue'
import AppLoadingCircular from '@/components/AppLoadingCircular.vue'
import IntegrationsDraggableTable from '@/components/IntegrationsDraggableTable.vue'
import IntegrationsHeader from '@/components/IntegrationsHeader.vue'
import IntegrationsSearch from '@/components/IntegrationsSearch.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { cloneDeep } from 'lodash'

@Component({
    name: 'Integrations',
    components: {
        AppHeader,
        AppLoadingCircular,
        FontAwesomeIcon,
        IntegrationsHeader,
        IntegrationsSearch,
        IntegrationsDraggableTable,
    },
})

export default class Integrations extends Vue {
    get rows() {
        return this.$store.state.integration.integrationModules
    }

    get isLoading(): boolean {
        return this.$store.state.integration.isLoading
    }

    get filters() {
        return this.$store.state.integration.filters
    }

    get disableTable() {
        return (
            this.filters.name !== '' ||
            this.filters.partner !== '' ||
            this.filters.category !== '' ||
            this.filters.status !== '' ||
            this.filters.onlySpotlight !== false ||
            this.isLoading
        )
    }

    @Watch('filters')
    public onChangeFilters(newFilters: any, _: any) {
        this.$router.replace({ query: {
            name: newFilters.name,
            partner: newFilters.partner,
            category: newFilters.category,
            status: newFilters.status,
            onlySpotlight: newFilters.onlySpotlight ? '1' : '0',
        }}).catch(() => {
            // Não deveria acontecer
        })
    }

    private parseFilters() {
        const query = cloneDeep(this.filters)
        const queryString = this.$route.query

        const name = queryString.name
        const partner = queryString.partner
        const category = queryString.category
        const status = queryString.status
        const onlySpotlight = queryString.onlySpotlight

        if (typeof name === 'string') {
            query.name = name
        }

        if (typeof partner === 'string') {
            query.partner = partner
        }

        if (typeof category === 'string') {
            query.category = category
        }

        if (typeof status === 'string') {
            query.status = status
        }

        if (typeof onlySpotlight === 'string') {
            query.onlySpotlight = onlySpotlight !== '0'
        }

        return query
    }
}
